var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-breadcrumb',{staticClass:"breadcrumb"},[_c('a-breadcrumb-item',[_vm._v("首页")]),_c('a-breadcrumb-item',[_vm._v("教务中心")]),_c('a-breadcrumb-item',[_vm._v("班级相册")])],1),_c('div',{staticClass:"main-box"},[_c('albums')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }